import React from 'react';
import ErrorPage from '../pages/_error';

interface Props {
  statusCode?: number;
  error?: Error;
}

/**
 * Simple HOC to wrap pages that fetches data in `getInitialProps`
 * If you return `statusCode` in `getInitialProps` in `Component`, it will
 * trigger the rendering of a ErrorPage.
 *
 * @param Component
 */
export default (Component): typeof Component => {
  return class WithError extends React.Component<Props> {
    static async getInitialProps(ctx): Promise<Props> {
      const props = (Component.getInitialProps ? await Component.getInitialProps(ctx) : null) || {};
      if (props.statusCode && ctx.res) {
        ctx.res.statusCode = props.statusCode;
      }
      return props;
    }

    render(): JSX.Element {
      if (this.props.statusCode) {
        return <ErrorPage hasGetInitialPropsRun={false} err={this.props.error} statusCode={this.props.statusCode} />;
      }
      return <Component {...this.props} />;
    }
  };
};
